"use client";
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";
import { PropsWithChildren } from "react";

interface CardProps {
  id: string;
  children: React.ReactNode;
  className?: string;
}

export const AnimatedCard: React.FC<CardProps> = ({
  id,
  children,
  className = "",
}) => {
  return (
    <motion.div
      layoutId={id}
      layout
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{
        layout: { type: "spring", stiffness: 200, damping: 30 },
        opacity: { duration: 0.2 },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const AnimatedCardContainer: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return <AnimatePresence mode="popLayout">{children}</AnimatePresence>;
};
